/**
 * Copy-to-clipboard for the contact e-mail cards (.js-copy).
 *
 * Progressive enhancement: the mailto link is always the primary action, this
 * just adds a one-click "copy the address" affordance (Figma annotation on the
 * contact cards). On success the button flips to a check + "Copiato!" bubble
 * (see .contact-card__copy.is-copied in _contact.scss) for ~2s.
 */
(function () {
	'use strict';

	var buttons = document.querySelectorAll('.js-copy');
	if (!buttons.length) {
		return;
	}

	function copyText(text) {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			return navigator.clipboard.writeText(text);
		}
		// Fallback for older/insecure contexts.
		return new Promise(function (resolve, reject) {
			try {
				var ta = document.createElement('textarea');
				ta.value = text;
				ta.setAttribute('readonly', '');
				ta.style.position = 'absolute';
				ta.style.left = '-9999px';
				document.body.appendChild(ta);
				ta.select();
				document.execCommand('copy');
				document.body.removeChild(ta);
				resolve();
			} catch (err) {
				reject(err);
			}
		});
	}

	for (var i = 0; i < buttons.length; i++) {
		(function (btn) {
			var timer = null;

			btn.addEventListener('click', function () {
				var text = btn.getAttribute('data-copy');
				if (!text) {
					return;
				}

				copyText(text).then(function () {
					btn.classList.add('is-copied');
					clearTimeout(timer);
					timer = setTimeout(function () {
						btn.classList.remove('is-copied');
					}, 2000);
				}).catch(function () {});
			});
		})(buttons[i]);
	}
})();
